import type { PlayInfo } from '@module/apis/client-side/live/type';
import type { ChatUIAffectingMessage } from '@module/types/centrifuge/chatTypes';

function parseEnterChat(playInfo: PlayInfo) {
  if (!playInfo) return null;
  if (!playInfo.enterChat) return null;
  if (!playInfo.enterChat[0]) return null;

  if (typeof (playInfo.enterChat[0] as any).message === 'string') {
    return {
      data: {
        type: (playInfo.enterChat[0] as any).type,
        message: JSON.parse((playInfo.enterChat[0] as any).message),
      },
    };
  }

  return playInfo.enterChat[0] as ChatUIAffectingMessage;
}

export default parseEnterChat;
